import Box1 from './compomnents/Box1/Box1'
import Box2 from './compomnents/Box2/Box2';
import Footer from './compomnents/Footer/footer';

const Main = () => {
    return (
    <div className='MinApp'>
    <Box1/>
    <Box2/>
    <Footer/>
    </div>  
    );
}
 
export default Main;